const Joi = require("joi");

const userRegisterSchema = (data) => {
  const schema = Joi.object({
    firstName: Joi.string()
      .trim()
      .pattern(new RegExp("^[a-zA-Z0-9]+(?: [a-zA-Z0-9]+)*$"))
      .required()
      .max(25)
      .messages({
        "string.pattern.base": "Please enter valid First name.",
        "string.max": "Please enter First name with fewer than 25 characters.",
        "any.required": "Please enter First name.",
        "string.empty": "Please enter First name.",
      }),

    lastName: Joi.string()
      .trim()
      .pattern(new RegExp("^[a-zA-Z0-9]+(?: [a-zA-Z0-9]+)*$"))
      .required()
      .max(25)
      .messages({
        "string.pattern.base": "Please enter valid Last name.",
        "string.max": "Please enter Last name with fewer than 25 characters.",
        "any.required": "Please enter Last name.",
        "string.empty": "Please enter Last name.",
      }),

    email: Joi.string()
      .trim()
      .email({ tlds: { allow: false } })
      .pattern(
        new RegExp(
          /^(?!.*\.\.)[a-zA-Z0-9._!#$*+%+-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+$/
        )
      )
      .required()
      .messages({
        "string.email": "Please enter valid email.",
        "string.pattern.base": "Please enter valid email.",
        "string.empty": "Please enter email.",
        "any.required": "Please enter email.",
      }),

    phoneNumber: Joi.string()
      .trim()
      .pattern(/^\(\d{3}\)\s\d{3}-\d{4}$/)
      .optional() // not required
      .allow("")
      .messages({
        "string.pattern.base":
          "Please enter a valid phone number (e.g., (777) 777-7777).",
      }),

    password: Joi.string()
      // .pattern(new RegExp("^[a-zA-Z0-9]+$"))
      .pattern(
        new RegExp(/^(?=.*\d)(?=.*[a-z])[\w~@#$%^&*+=`|{}:;!.?"()\[\]-]{8,50}$/)
      )
      .required()
      .messages({
        "string.pattern.base":
          "Password should contain letter, numbers and minimum 8 characters.",
        "any.required": "Please enter password.",
        "string.empty": "Please enter password.",
      }),

    confirmPassword: Joi.string()
      .valid(Joi.ref("password"))
      .required()
      .messages({
        "any.only": "Confirm password must match the password.",
        "any.required": "Please enter confirm password.",
        "string.empty": "Please enter confirm password.",
      }),

    // committees: Joi.array()
    //   .items(
    //     Joi.object({
    //       label: Joi.string().required(),
    //       value: Joi.string().required(), // can add regex for ObjectId if needed
    //     })
    //   )
    //   .min(1)
    //   .required()
    //   .messages({
    //     "array.base": "Please select at least one Committee.",
    //     "array.min": "Please select at least one Committee.",
    //     "any.required": "Please select Committee.",
    //   }),

    committees: Joi.array()
      .items(
        Joi.string().required().messages({
          "string.base": "Invalid Committee", //not a string
          "any.required": "Committee ID is required.",
        })
      )
      .min(1)
      .required()
      .messages({
        "array.base": "Committees must be an array.",
        "array.min": "Please select at least one committee.",
        "any.required": "Committees are required.",
      }),

    organization: Joi.string()
      .trim()
      .max(256)
      .when("participateKids", {
        is: 1,
        then: Joi.string().required().messages({
          "string.empty": "Organization name is required.",
          "string.max": "Organization name must be fewer than 256 characters.",
        }),
        otherwise: Joi.string().optional().allow(""),
      }),
  }).unknown(true);

  return schema.validate(data, {
    abortEarly: false,
  });
};

module.exports = userRegisterSchema;
